define('lq/licquidRuntimeSpa',[
    'lq',
    'underscore',
    'drops/action/action',
    'lq/runtimePiping',
    'lq/parameterShell',
    'lq/actionLoader',
    'lq/navigatorSpa',
    'lq/style',
    'lq/windowSize',
    'lq/responsive',
    'lq/services/application/applicationServiceFactory',
    'lq/validatorGateway',
    'lq/highlighter',
    'lq/layouting',
    'lq/javascript/polyfill'
], function (lq, _, Action, RuntimePiping, ParameterShell, ActionLoader, NavigatorSpa, Style, windowSize, responsive, applicationServiceFactory, validatorGateway, highlighter, layouting, pullDownAction) {

    var deferredPrompt = null;
    if (!responsive.isPWA()) {
        // Running in Browser
        window.addEventListener('beforeinstallprompt', function (e) {
            deferredPrompt = e;
        });
    }

    var inIframe = function () {
        return window !== window.parent;
    };

    var LicquidRuntimeSpa = function () {
        if (window.cordova) {
            document.addEventListener('deviceready', function () {
                if (window.universalLinks) {
                    window.universalLinks.subscribe(null, function (eventData) {
                        window.location = eventData.url;
                    });
                }
            }, false);
        }
    };

    LicquidRuntimeSpa.prototype.start = function (setup) {
        if (setup.application.embedded) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'LicquidLoaded'
            }), '*');
        }

        var self = this;
        windowSize.withOnChanged(function () {
            if (self.action) self.action.resize();
        });

        window.addEventListener('popstate', function (e) {
            self.openNewAction(e.state.actionId, e.state.globals, e.state.locals, { ignoreHistory: true });
        });

        Style.defaultStyles = setup.application.styles.defaultStyles;
        Style.defaultMockStyles = setup.application.styles.defaultMockStyles;
        Style.mockMode = setup.isInMockMode;

        this.action = null;
        
        this.$app = setup.$el;
        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo(this.$app);
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);

        this.globalPiping = RuntimePiping.createRoot(setup.parameters.globals, setup.application, this.$app);
        this.globalPiping.navigator = NavigatorSpa.withLocalStorage(setup.action.id, this.globalPiping.url, this.openNewAction.bind(this));
        this.globalPiping.errorHandler.addListener(this.handleError.bind(this));
        this.globalPiping.runtime = this;

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'LICQUID_RUNTIME_LOADED',
                globalPiping: this.globalPiping
            });
        } else {
            validatorGateway.whenEnabled(function () {
                validatorGateway.publishEvent({
                    type: 'LICQUID_RUNTIME_LOADED',
                    globalPiping: self.globalPiping
                });

                if (self.action !== null) {
                    validatorGateway.registerListener(self.action.instanceId, self.receiveMessage.bind(self));

                    validatorGateway.publishEvent({
                        type: 'ACTION_INSTANCE_LOADED',
                        action: self.action,
                        canReload: false
                    });
                }
            });
        }

        this.globalServices = _.map(setup.application.services, function (service) {
            return applicationServiceFactory.createService(service);
        });
        _.forEach(this.globalServices, function (globalService) {
            globalService.initialize(self);
        });

        this.application = setup.application;
        
        this.actionLoader = new ActionLoader(this.globalPiping.url);
        this.actionLoader.addListener(this.showAction.bind(this));

        this.globalPiping.busyIndicator.show();
        this.openNewAction(setup.action.id, setup.parameters.globals, setup.parameters.locals);

        this.globalPiping.deferredPrompt = deferredPrompt;
    };

    LicquidRuntimeSpa.prototype.showAction = function (setup, parameters, state) {
        $.extend(this.globalPiping.application, setup.application);

        if(setup.view.insertionPoint) {
            var index = this.insertionPoints.indexOf(setup.view.insertionPoint);
            this.insertionPoints = this.insertionPoints.slice(0, index + 1);
            this.insertionPoints = this.insertionPoints
                .concat(_.map(setup.view.actions, function(action) {
                    return action.action.id;
                }));

            this.action.setContent(setup.view.actions, parameters.locals, setup.view.insertionPoint);
    
            this.updateHistory(setup, _.last(setup.view.actions).action.id, parameters, state);
        } else {
            this.insertionPoints = _.map(setup.view.actions, function(action) {
                return action.action.id;
            });

            var actionData = setup.view.actions[0].action;
            var systemParameters = setup.view.actions[0].systemParameters;
            var localParameters = setup.view.actions.length > 1 ? {} : parameters.locals;

            var action = new Action(actionData.view, this.globalPiping.application.options);
            action.loadData(actionData);
            action.piping = this.globalPiping.createChildPiping(actionData, action, localParameters, systemParameters, this.$wrapper, this.$view, !this.action && window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD);
            action.globals = _.clone(parameters.globals);
            action.locals = _.clone(parameters.locals);

            var layout = responsive.getCurrentLayout(action);
            layouting.applyLayout(this.$view, layout);
            
            var notInsideIFrame = window.top.location === window.location;
            action.applyLayout(layout, notInsideIFrame);

            if (action.shouldUseWidthOfLayout()) {
                action.data.size.x = layout.resolutionX;
            }

            if(document.startViewTransition) {
                var transition = document
                    .startViewTransition(() => {
                        var promise = this.startActionRender(action, setup, parameters);
                        this.postActionRender(action, setup, parameters, state)
                        return promise;
                    });
                transition.updateCallbackDone
                    .then(() => action.startEventing());     
            } else {
                this.startActionRender(action, setup, parameters)
                    .then(function() {
                        action.startEventing();
                    });
                this.postActionRender(action, setup, parameters, state);
            }
        }
    };
        
    LicquidRuntimeSpa.prototype.startActionRender = function (action, setup, parameters) {
        // todo svb SPA viewport should only be set once (but what with "growable" actions?)
        return action.createAndRenderDrops($('#viewport'))
            .then(function () {
                action.setContent(setup.view.actions.slice(1), parameters.locals);
            });
    };

    LicquidRuntimeSpa.prototype.postActionRender = function (action, setup, parameters, state) {
        if (this.action) {
            if(validatorGateway.isEnabled()) {
                validatorGateway.unregisterListener(this.action.instanceId);

                validatorGateway.publishEvent({
                    type: 'ACTION_INSTANCE_UNLOADING',
                    action: this.action
                });
            }

            this.action.piping.cleanUp();
            this.action.unsubscribeEventHandlersRecursive();

            this.updateHistory(setup, _.last(setup.view.actions).action.id, parameters, state);
        } else {
            window.history.replaceState({
                actionId: _.last(setup.view.actions).action.id,
                globals: parameters.globals,
                locals: parameters.locals
            }, '', this.application.hideUrl ? lq.getTenantUrl('') : window.location.href);
        }

        this.$wrapper.scrollTop(0);
        this.action = action;
        this.action.piping.busyIndicator.forceHide();

        if(validatorGateway.isEnabled()) {
            validatorGateway.registerListener(action.instanceId.toString(), this.receiveMessage.bind(this));

            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_LOADED',
                action: action,
                canReload: setup.view.actions.length === 1
            });
        }

        if (inIframe()) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'EmbeddedActionLoaded',
                sizeX: action.data.size.x,
                sizeY: action.data.size.y
            }), window.location.protocol + '//' + window.location.host);
        }
    };

    LicquidRuntimeSpa.prototype.updateHistory = function (setup, actionId, parameters, state) {
        if (!state || !state.ignoreHistory) {
            var pageUrl = setup.friendlyName
                ? setup.friendlyName
                : 'LicquidAction/Get/' + actionId;

            var currentParameters = {};
            if (_.keys(parameters.globals).length)
                currentParameters.globals = JSON.stringify(parameters.globals);
            if (_.keys(parameters.locals).length)
                currentParameters.parameters = JSON.stringify(parameters.locals);
            
            var currentUrl = this.application.hideUrl
                ? lq.getTenantUrl('')
                : this.globalPiping.url.prepare(lq.getTenantUrl(pageUrl), currentParameters);

            window.history.pushState({
                    actionId: actionId,
                    globals: parameters.globals,
                    locals: parameters.locals
                },
                '',
                currentUrl);
        }
    };

    LicquidRuntimeSpa.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.openNewAction(this.action.data.id, this.action.globals, this.action.locals, { ignoreHistory: true });
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    LicquidRuntimeSpa.prototype.openNewAction = function (actionId, globals, locals, state) {
        this.actionLoader.load(actionId, globals, locals, state, this.insertionPoints);
    };

    LicquidRuntimeSpa.prototype.handleError = function (errorArgs) {
        if (this.action) this.action.error(errorArgs);
    };

    return LicquidRuntimeSpa;
});
